import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KumiaiinGetsujiShimeKbn = props => {
  return <Dropdown.Static kubunKey='kumiaiin_getsuji_shime_kbn' {...props} />
}
